import React, { memo } from 'react';

import { useHistory } from 'react-router-dom';

import { ChildrenPropType } from '../../../../prop-types/children';
import { BASE_ORDERS_PATH, BASE_SHIPMENTS_PATH, SHIPMENTS_RETURNS_PATH } from '../../../../routes/constants';
import { defaultOrderDetailsNavigationContext, OrderDetailsNavigationContext } from './order-details-navigation-context';
import OrdersPageNavigationContextProvider from './orders-page-navigation-context-provider';
import ShipmentsPageNavigationContextProvider from './shipments-page-navigation-context-provider';

const OrderDetailsNavigationContextProvider = ({ children }) => {
  const history = useHistory();
  const pathname = history.location.pathname;

  if (pathname.startsWith(BASE_ORDERS_PATH)) {
    return <OrdersPageNavigationContextProvider>{children}</OrdersPageNavigationContextProvider>;
  }

  if (pathname.startsWith(BASE_SHIPMENTS_PATH) && !pathname.includes(SHIPMENTS_RETURNS_PATH)) {
    return <ShipmentsPageNavigationContextProvider>{children}</ShipmentsPageNavigationContextProvider>;
  }

  return (
    <OrderDetailsNavigationContext.Provider value={defaultOrderDetailsNavigationContext}>{children}</OrderDetailsNavigationContext.Provider>
  );
};

export default memo(OrderDetailsNavigationContextProvider);

OrderDetailsNavigationContextProvider.propTypes = {
  children: ChildrenPropType.isRequired,
};
